import React from 'react';
import PropTypes from 'prop-types';
import FamilyLeaf from './FamilyLeaf';

const FamilyTree = ({ pedigree }) => (
    <div className="hp-familyTree hp-pedigree__familyTree hidden-sm-down">
        <div className="hp-familyTree__leaf">
            <FamilyLeaf data={pedigree} />
        </div>
        <div className="hp-familyTree__stage hp-familyTree__stage_second">
            <div className="hp-familyTree__branches">
                <div className="hp-familyTree__branch" />
            </div>
            <div className="hp-familyTree__leaf">
                <FamilyLeaf data={pedigree.sire} />
                <FamilyLeaf data={pedigree.dam} />
            </div>
        </div>
        <div className="hp-familyTree__stage hp-familyTree__stage_third">
            <div className="hp-familyTree__section">
                <div className="hp-familyTree__branches">
                    <div className="hp-familyTree__branch" />
                </div>
                <div className="hp-familyTree__leaf">
                    <FamilyLeaf data={pedigree.sire && pedigree.sire.sire} />
                    <FamilyLeaf data={pedigree.sire && pedigree.sire.dam} />
                </div>
            </div>
            <div className="hp-familyTree__section">
                <div className="hp-familyTree__branches">
                    <div className="hp-familyTree__branch" />
                </div>
                <div className="hp-familyTree__leaf">
                    <FamilyLeaf data={pedigree.dam && pedigree.dam.sire} />
                    <FamilyLeaf data={pedigree.dam && pedigree.dam.dam} />
                </div>
            </div>
        </div>
    </div>
);

const horseTypes = {
    countryOriginCode: PropTypes.string,
    horseDateOfBirth: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
};
const horseShape = PropTypes.shape(horseTypes);
const sireOrDamShape = PropTypes.shape({
    ...horseTypes,
    sire: horseShape,
    dam: horseShape,
});

FamilyTree.propTypes = {
    pedigree: PropTypes.shape({
        ...horseTypes,
        sire: sireOrDamShape,
        dam: sireOrDamShape,
    }).isRequired,
};

export default FamilyTree;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/familyTree/FamilyTree.jsx